var map = {
	"./equality.svg": 7097,
	"./flag-br.svg": 3696,
	"./flag-enus.svg": 5261,
	"./flag-pt.svg": 856,
	"./flag-ptbr.svg": 900,
	"./flag-uk.svg": 1576,
	"./flag-us.svg": 6960,
	"./g-scholar.svg": 61,
	"./lattes.svg": 1268,
	"./logo.svg": 576,
	"./orcid-id.svg": 1368,
	"./pdf-file.svg": 3880,
	"./skills/emotional-intellectual-assessment.svg": 5192,
	"./skills/intellectual-assessment.svg": 907,
	"./skills/lang-python.svg": 7261,
	"./skills/lang-r.svg": 9495,
	"./skills/neuropsychology.svg": 528,
	"./skills/psychometrics.svg": 3753,
	"./skills/psychopharmacology.svg": 9704,
	"./skills/research-design.svg": 1588,
	"./skills/statistical-modeling.svg": 2897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7288;